export const EVENT_ORDER = window.EVENT_ORDER;
/**
 * @constant {Object} - Исходный объект заказа полученный из сервера
 * {
 *   id,
 *   carts {Array} - [{ event_id, ... }, ... ]
 * }
 */
export const INITIAL_EVENT_ORDER = window.INITIAL_EVENT_ORDER;
